var loaders = require('../../layout/components/loaders');
var ontologyColumns = require('../../../../../models/equipment/ontologyColumns');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');

const equipmentModel = {};

equipmentModel.equipmentClassTree = {categories: [], equipment: {}, classes: {}};

function normalizeClassTreeFields(category) {
  if (!category || typeof category !== 'object') return;
  if (!category.data || typeof category.data !== 'object') {
    category.data = {};
  }
  category.data.fields = ontologyFields.normalizeFieldDefinitions(category.data.fields);
  category.data.columns = ontologyColumns.normalizeColumnDefinitions(category.data.columns);
  category.data.datasets = ontologyColumns.normalizeDatasetDefinitions(category.data.datasets);
  (Array.isArray(category.children) ? category.children : []).forEach(normalizeClassTreeFields);
}

equipmentModel.requestClassTree = function () {
  equipmentModel.equipmentClassTree = {categories: [], equipment: {}};
  return loaders.requestWithLoader({
    loader: 'main',
    url: '/api/v1/ontology/classtree?type=equipment',
    method: 'GET'
  })
  .then(res => {
    equipmentModel.equipmentClassTree = res;
    (equipmentModel.equipmentClassTree.categories || []).forEach(normalizeClassTreeFields);
    equipmentModel.equipmentClassTree.categories.forEach((c, i) => columnsByMainEquipmentCategory(c, i))
    equipmentModel.equipmentClassTree.categories.unshift({name: 'Overview'})
    return equipmentModel.equipmentClassTree;
  })
}

equipmentModel.getClassTree = function () {
  if (!equipmentModel.equipmentClassTree.categories.length) {
    return equipmentModel.requestClassTree()
  } else {
    return Promise.resolve(equipmentModel.equipmentClassTree);
  }
};

equipmentModel.saveChildrenClassData = function (data) {
  return loaders.requestWithLoader({
    loader: 'main',
    url: '/api/v1/ontology/classdata?type=equipment',
    method: 'POST',
    body: data
  })
  .then(res => {
    return equipmentModel.requestClassTree();
  })
  .then(response => {
    return response;
  })
};

equipmentModel.renameClass = function (originalName, newName) {
  return loaders.requestWithLoader({
    loader: 'main',
    url: `/api/v1/ontology/class/${encodeURIComponent(originalName)}?type=equipment`,
    method: 'PUT',
    body: { name: newName }
  })
  .then(() => {
    return equipmentModel.requestClassTree();
  });
};

equipmentModel.deleteClass = function (className) {
  return loaders.requestWithLoader({
    loader: 'main',
    url: `/api/v1/ontology/class/${encodeURIComponent(className)}?type=equipment`,
    method: 'DELETE'
  })
  .then(() => {
    return equipmentModel.requestClassTree();
  });
};

function columnsByMainEquipmentCategory (mainEquipmentCategory, idx){
  equipmentModel.equipmentClassTree.categories[idx].allChildrenColumns = [];
  let mainEquipmentCategoryData = equipmentModel.equipmentClassTree.categories[idx];
  addCategoryColumns(mainEquipmentCategoryData, idx);
}

function addCategoryColumns (category, idx){
  if (category.data && Array.isArray(category.data.datasets)) {
    category.data.datasets.forEach(dataset => {
      if (dataset && Array.isArray(dataset.columns)) {
        dataset.columns.forEach(columnRecord => {
          if (!equipmentModel.equipmentClassTree.categories[idx].allChildrenColumns.find(c => c.name == columnRecord.name)) {
            equipmentModel.equipmentClassTree.categories[idx].allChildrenColumns.push(columnRecord)
          }
        })
      }
    })
  }
  if(Array.isArray(category.children) && category.children.length > 0) {
    category.children.forEach(childrenCategory =>{
      addCategoryColumns(childrenCategory, idx)
    })
  }
}

equipmentModel.classBelongToMainClass = function(classToFind, mainClass) {
  let filteredTree = equipmentModel.equipmentClassTree.categories.filter(c => c.name == mainClass);
  if (filteredTree.length === 0) return false;
  let found = { value: false };
  findClassInTree(filteredTree[0].children, classToFind, found);
  return found.value;
}

function findClassInTree(tree, className, found) {
  if (tree) {
    tree.forEach(c => {
      if (c.name === className) {
        found.value = true;
      }
      if (c.children && c.children.length > 0 && !found.value) {
        findClassInTree(c.children, className, found);
      }
    });
  }
}

equipmentModel.findClassData = function(classToFind) {
  let foundEquipmentClass = null;

  function findClassFromCategory(category) {
    if (category.name === classToFind) {
      foundEquipmentClass = { ...category };
      return; // Stop further recursion
    }

    if (Array.isArray(category.children) && category.children.length > 0) {
      for (const child of category.children) {
        if (!foundEquipmentClass) {
          findClassFromCategory(child);
        }
      }
    }
  }

  for (const category of equipmentModel.equipmentClassTree.categories) {
    if (!foundEquipmentClass) {
      findClassFromCategory(category);
    }
  }

  return foundEquipmentClass;
}

equipmentModel.getInheretedClassData = function(className) {
  var foundEquipmentClass = {};
  var parentFieldsArray = [];
  var parentClasses = {};
  var parentDatasetsArray = [];
  var parentPortsArray = [];
  var classFound = {};

  findClassDataFromEquipmentTree(
    equipmentModel.equipmentClassTree.categories, 
    className, 
    foundEquipmentClass, 
    parentDatasetsArray, 
    parentFieldsArray, 
    parentPortsArray,
    parentClasses,
    classFound
  );
  
  return {
    foundEquipmentClass,
    parentFieldsArray,
    parentDatasetsArray,
    parentPortsArray,
  }
}

function findClassDataFromEquipmentTree(
  classTreeCategories, 
  customEquipmentClass, 
  foundEquipmentClass, 
  parentDatasetsArray, 
  parentFieldsArray, 
  parentPortsArray, 
  parentClasses, 
  equipmentClass,
  classFound
) {
  classTreeCategories.forEach(category => {
    if (Object.keys(foundEquipmentClass).length === 0) {
      findClassFromCategory(
        classTreeCategories, 
        category, 
        foundEquipmentClass, 
        customEquipmentClass, 
        parentDatasetsArray, 
        parentFieldsArray, 
        parentPortsArray, 
        parentClasses, 
        equipmentClass,
        classFound
      );
    }

  })
  return foundEquipmentClass;
}


function findClassFromCategory(
  classTreeCategories, 
  category, 
  foundEquipmentClass, 
  customEquipmentClass, 
  parentDatasetsArray, 
  parentFieldsArray, 
  parentPortsArray, 
  parentClasses,
  classFound
) {
  
  if (category.name == customEquipmentClass) {
    Object.assign(foundEquipmentClass, JSON.parse(JSON.stringify(category)));
    if (Object.keys(classFound).length == 0) {
      Object.assign(classFound, JSON.parse(JSON.stringify(category)));
    }
    collectDataFromParentEquipmentClass(
      classTreeCategories, 
      foundEquipmentClass, 
      parentDatasetsArray, 
      parentFieldsArray, 
      parentPortsArray, 
      parentClasses,
      classFound
    )
  } else if (Array.isArray(category.children) && category.children.length > 0) {
    category.children.forEach(childrenCategory => {
      if (Object.keys(foundEquipmentClass).length === 0) {
        findClassFromCategory(
          classTreeCategories, 
          childrenCategory, 
          foundEquipmentClass, 
          customEquipmentClass, 
          parentDatasetsArray, 
          parentFieldsArray, 
          parentPortsArray, 
          parentClasses,
          classFound
        )
      }
    })
  }
}


function collectDataFromParentEquipmentClass(
  classTreeCategories, 
  foundEquipmentClass, 
  parentDatasetsArray, 
  parentFieldsArray, 
  parentPortsArray, 
  parentClasses,
  classFound
) {
  if (foundEquipmentClass.parent) {
    parentClasses[foundEquipmentClass.name] = foundEquipmentClass.parent;
    parentClasses[foundEquipmentClass.parent] = {};

    findClassDataFromEquipmentTree(
      classTreeCategories, 
      foundEquipmentClass.parent, 
      parentClasses[foundEquipmentClass.parent], 
      parentDatasetsArray, 
      parentFieldsArray, 
      parentPortsArray, 
      parentClasses,
      classFound
    );
    if (foundEquipmentClass && foundEquipmentClass.data && foundEquipmentClass.data.datasets && foundEquipmentClass.name != classFound.name) {
      foundEquipmentClass.data.datasets.forEach(g => {
        g.definedBy = foundEquipmentClass.name
        if (g.columns && Array.isArray(g.columns)) {
          g.columns = ontologyColumns.normalizeColumnDefinitions(g.columns).map(column => Object.assign({}, column, {
            definedBy: foundEquipmentClass.name
          }));
        }
        let existingDatasetIdx = parentDatasetsArray.findIndex(dataset => dataset.name === g.name);
        if (existingDatasetIdx !== -1) {
          parentDatasetsArray[existingDatasetIdx] = ontologyColumns.mergeDatasetDefinitions(
            Object.assign({}, g),
            parentDatasetsArray[existingDatasetIdx]
          );
        } else {
          parentDatasetsArray.push(ontologyColumns.normalizeDatasetDefinition(g));
        }
      });
      
      if (foundEquipmentClass.data.fields && Array.isArray(foundEquipmentClass.data.fields)) {
        ontologyFields.normalizeFieldDefinitions(foundEquipmentClass.data.fields).forEach(f => {
          var fieldName = ontologyFields.getFieldName(f);
          if (!fieldName) return;
          var normalizedField = Object.assign({}, f, {
            definedBy: foundEquipmentClass.name
          });
          var existingIdx = parentFieldsArray.findIndex(parentField => parentField.name === fieldName);
          if (existingIdx !== -1) {
            parentFieldsArray[existingIdx] = Object.assign({}, parentFieldsArray[existingIdx], normalizedField);
            return;
          }
          parentFieldsArray.push(normalizedField);
        });
      }
      
      if (foundEquipmentClass.data.ports && Array.isArray(foundEquipmentClass.data.ports)) {
        foundEquipmentClass.data.ports.forEach(p => {
          parentPortsArray.push({
            ...p,
            definedBy: foundEquipmentClass.name
          });
        });
      }
      if (foundEquipmentClass.parent != 'Equipment') {
        collectDataFromParentEquipmentClass(classTreeCategories, parentClasses[foundEquipmentClass.parent], parentDatasetsArray, parentFieldsArray, parentPortsArray, parentClasses);
      }
    }
  }
}





module.exports = equipmentModel;
